import { addToast } from '@mobi/component-library/Feedback/Toast'
import { isBetLoopProblemResponse } from '@core/Areas/BetLoop/helpers/api/typeGuards'
import type { ProblemResponse } from '@core/Areas/BetLoop/helpers/api/types'

export async function handleApiErrorNotification(err: Error | ProblemResponse) {
  if (!isBetLoopProblemResponse(err)) return

  if ((err.detail || err.title) && err.requestId) {
    addToast({
      id: err.requestId,
      title: err.detail || err.title,
      icon: 'error',
      theme: 'dark',
    })
  }
}
